import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const AccountTransactionSchema = withDefaults({
  type: 'account-transaction',
  objectExtensions: ['account-transaction'],
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'transactionDate',
    },
    {
      kind: 'attribute',
      name: 'transactionType',
    },
    {
      kind: 'attribute',
      name: 'category',
    },
    {
      kind: 'attribute',
      name: 'verificationState',
    },
    {
      kind: 'attribute',
      name: 'createdAt',
    },
    {
      kind: 'attribute',
      name: 'deletedAt',
    },
    {
      kind: 'attribute',
      name: 'transitionLog',
    },
    {
      kind: 'hasMany',
      name: 'matchPayments',
      type: 'match-payment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'hasMany',
      name: 'matchAssets',
      type: 'match-asset',
      options: {
        async: false,
        inverse: 'accountTransactions',
      },
    },
    {
      kind: 'belongsTo',
      name: 'financialInstitution',
      type: 'financial-institution',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'person',
      type: 'person',
      options: {
        async: false,
        inverse: 'accountTransactions',
      },
    },
    {
      kind: 'belongsTo',
      name: 'observableDocument',
      type: 'observable-document',
      options: {
        async: false,
        inverse: 'accountTransactions',
      },
    },
    {
      kind: 'belongsTo',
      name: 'account',
      type: 'account',
      options: {
        async: false,
        inverse: 'accountTransactions',
      },
    },
  ],
});

export default AccountTransactionSchema;
